import request from '@/utils/request'

// 查询列表
export function creatWatermarkReq(params) {
    return request.post('/horo-service/web/watermark/makeTransparentWatermark',params)
}
